import { Container as MantineContainer, ContainerProps } from '@mantine/core';

export type IContainerProps = ContainerProps;

/** @registry Design-layer pass-through over Mantine Container; import this instead of @mantine/core Container outside src/design. */
export const Container = MantineContainer;
